__turbopack_context__.v({
  "antCardBody": "a149aW_antCardBody",
  "button": "a149aW_button",
  "cardFixed": "a149aW_cardFixed",
  "cardLeft": "a149aW_cardLeft",
  "cardRight": "a149aW_cardRight",
  "cards": "a149aW_cards",
  "centerImage": "a149aW_centerImage",
  "compareSection": "a149aW_compareSection",
  "content": "a149aW_content",
  "headContact": "a149aW_headContact",
  "imageWrapper": "a149aW_imageWrapper",
  "left1": "a149aW_left1",
  "left2": "a149aW_left2",
  "line": "a149aW_line",
  "lineMobile": "a149aW_lineMobile",
  "netralcolor": "a149aW_netralcolor",
  "p": "a149aW_p",
  "page-body-wrap": "a149aW_page-body-wrap",
  "pagehero": "a149aW_pagehero",
  "paragraph": "a149aW_paragraph",
  "paragraph-content": "a149aW_paragraph-content",
  "paragraph1": "a149aW_paragraph1",
  "phonecontent": "a149aW_phonecontent",
  "right1": "a149aW_right1",
  "right2": "a149aW_right2",
  "store": "a149aW_store",
  "subText": "a149aW_subText",
  "t": "a149aW_t",
  "title": "a149aW_title",
  "title1": "a149aW_title1",
  "wrap-container": "a149aW_wrap-container",
  "wrap-content": "a149aW_wrap-content",
  "wrapper": "a149aW_wrapper",
});
